import { render, staticRenderFns } from "./QrBuddycomCallEasyLogin.vue?vue&type=template&id=04154ea4&scoped=true"
import script from "./QrBuddycomCallEasyLogin.vue?vue&type=script&lang=js"
export * from "./QrBuddycomCallEasyLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04154ea4",
  null
  
)

export default component.exports